import { AppState } from 'store/store';
import { topSearchSlice } from 'store/header/search/top-search-slice';

export const topSearchReducer = {
    search: topSearchSlice.reducer,
};

export type HeaderState = AppState;
